module.exports = __webpack_public_path__ + "assets/star.91c10562.svg";